import { createRouteMask, RouteMask } from "@tanstack/react-router";

import { routeTree } from "@/routeTree.gen";

//! VIEW

const logsModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/logs/$id/modal",
  to: "/dashboard/logs/$id",
  params: (prev) => ({ id: prev.id })
});

const orderModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/pedidos/$id/modal",
  to: "/dashboard/pedidos/$id",
  params: (prev) => ({ id: prev.id })
});

const profileModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/perfil/modal",
  to: "/dashboard/perfil"
});

//! EDIT
const editDriverModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/motoristas/editar/$id/modal",
  to: "/dashboard/motoristas/editar/$id",
  params: (prev) => ({ id: prev.id })
});

const editProductModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/produtos/editar/$id/modal",
  to: "/dashboard/produtos/editar/$id",
  params: (prev) => ({ id: prev.id })
});

const editCustomerModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/clientes/editar/$id/modal",
  to: "/dashboard/clientes/editar/$id",
  params: (prev) => ({ id: prev.id })
});

const editTruckShippingModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/caminhoes/carregamentos/editar/$id/modal",
  to: "/dashboard/caminhoes/carregamentos/editar/$id",
  params: (prev) => ({ id: prev.id })
});

const editTruckBrandModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/caminhoes/marcas/editar/$id/modal",
  to: "/dashboard/caminhoes/marcas/editar/$id",
  params: (prev) => ({ id: prev.id })
});

const editTruckModelModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/caminhoes/modelos/editar/$id/modal",
  to: "/dashboard/caminhoes/modelos/editar/$id",
  params: (prev) => ({ id: prev.id })
});

const editTruckModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/caminhoes/editar/$id/modal",
  to: "/dashboard/caminhoes/editar/$id",
  params: (prev) => ({ id: prev.id }),
  unmaskOnReload: false
});

const editShippingCompanyModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/transportadoras/editar/$id/modal",
  to: "/dashboard/transportadoras/editar/$id",
  params: (prev) => ({ id: prev.id })
});

const editCompanyModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/empresas/editar/$id/modal",
  to: "/dashboard/empresas/editar/$id",
  params: (prev) => ({ id: prev.id })
});

const editOrderModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/pedidos/editar/$id/modal",
  to: "/dashboard/pedidos/editar/$id",
  params: (prev) => ({ id: prev.id })
});

const editTermsModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/configuracoes/termos/$id/modal",
  to: "/dashboard/configuracoes/termos/$id",
  params: (prev) => ({ id: prev.id })
});

const editPopupModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/configuracoes/popups/$id/modal",
  to: "/dashboard/configuracoes/popups/$id",
  params: (prev) => ({ id: prev.id })
});

const editUsersModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/usuarios/editar/$id/modal",
  to: "/dashboard/usuarios/editar/$id",
  params: (prev) => ({ id: prev.id })
});

//! CREATE

const createCustomerModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/clientes/cadastrar/modal",
  to: "/dashboard/clientes/cadastrar"
});

const createTruckShippingModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/caminhoes/carregamentos/cadastrar/modal",
  to: "/dashboard/caminhoes/carregamentos/cadastrar"
});

const createTruckBrandModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/caminhoes/marcas/cadastrar/modal",
  to: "/dashboard/caminhoes/marcas/cadastrar"
});

const createTruckModelModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/caminhoes/modelos/cadastrar/modal",
  to: "/dashboard/caminhoes/modelos/cadastrar"
});

const createTruckModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/caminhoes/cadastrar/modal",
  to: "/dashboard/caminhoes/cadastrar"
});

const createDriversModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/motoristas/cadastrar/modal",
  to: "/dashboard/motoristas/cadastrar"
});

const createShippingCompaniesModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/transportadoras/cadastrar/modal",
  to: "/dashboard/transportadoras/cadastrar"
});

const createUsersModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/usuarios/cadastrar/modal",
  to: "/dashboard/usuarios/cadastrar"
});

const createCompanyModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/empresas/cadastrar/modal",
  to: "/dashboard/empresas/cadastrar"
});

const createOrderModalMaskedRoute = createRouteMask({
  routeTree,
  from: "/dashboard/pedidos/cadastrar/modal",
  to: "/dashboard/pedidos/cadastrar"
});

export const routeMasks: RouteMask<typeof routeTree>[] = [
  //! View
  logsModalMaskedRoute,
  orderModalMaskedRoute,
  profileModalMaskedRoute,
  //! Edit
  editDriverModalMaskedRoute,
  editProductModalMaskedRoute,
  editCustomerModalMaskedRoute,
  editShippingCompanyModalMaskedRoute,
  editCompanyModalMaskedRoute,
  editOrderModalMaskedRoute,
  editTermsModalMaskedRoute,
  editPopupModalMaskedRoute,
  editUsersModalMaskedRoute,
  //! Create
  createCustomerModalMaskedRoute,
  createDriversModalMaskedRoute,
  createShippingCompaniesModalMaskedRoute,
  createUsersModalMaskedRoute,
  createCompanyModalMaskedRoute,
  createOrderModalMaskedRoute,
  //! TRUCK ROUTES
  //! Edit
  editTruckShippingModalMaskedRoute,
  editTruckBrandModalMaskedRoute,
  editTruckModelModalMaskedRoute,
  editTruckModalMaskedRoute,
  //! Create
  createTruckShippingModalMaskedRoute,
  createTruckBrandModalMaskedRoute,
  createTruckModelModalMaskedRoute,
  createTruckModalMaskedRoute
];
